module.exports = __webpack_public_path__ + "img/motor_no15.8c78e67e.jpg";